import { render } from "./TaskManagement.vue?vue&type=template&id=4acc67a1&scoped=true&ts=true"
import script from "./TaskManagement.vue?vue&type=script&lang=ts"
export * from "./TaskManagement.vue?vue&type=script&lang=ts"

import "./TaskManagement.vue?vue&type=style&index=0&id=4acc67a1&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acc67a1"]])

export default __exports__